<template>
  <div>
    <b-card-code title="Export Data Device">
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label="Device"
                    label-for="v-Devices"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Devices"
                      rules="required"
                    >
                      <v-select
                        id="v-Devices"
                        v-model="recoverData.deviceGuid"
                        :options="items"
                        label="code"
                        placeholder="Devices"
                        class="w-100"
                        :reduce="v => v.serial_number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label="StartDate"
                    label-for="v-StartDate"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="StartDate"
                      rules="required"
                    >
                      <b-form-datepicker
                        id="v-StartDate"
                        v-model="recoverData.startTime"
                        placeholder="StartDate"
                        class="w-100"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label="EndDate"
                    label-for="v-EndDate"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="EndDate"
                      rules="required"
                    >
                      <b-form-datepicker
                        id="v-EndDate"
                        v-model="recoverData.endTime"
                        placeholder="EndDate"
                        class="w-100"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <b-progress
                v-if="sseData.isProcessing"
                :value="sseData.progress"
                :max="100"
                show-progress
                animated
              >
                <b-progress-bar :value="sseData.progress">
                  {{ sseData.progressMessage + ' ' + sseData.progress + '%' }}
                </b-progress-bar>
              </b-progress>
            </b-col>
            <b-col
              cols="12"
              class="mt-1 mb-1"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                :disabled="sseData.isProcessing"
                @click.prevent="updateDevice"
              >
                Submit
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-code>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BFormFile, BCard, BCardText, BTable, BProgress, BProgressBar, BRow, BCol, BImg, BBadge, BForm, BFormDatepicker, BMedia, BMediaAside, BMediaBody, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem, VBModal,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { required } from '@validations'
import XLSX from 'xlsx'
import moment from 'moment'
import axios from 'axios'
import store from '@/store/index'
import device from '@/store/modules/device'

export default {
  components: {
    ValidationProvider, ValidationObserver, vSelect, BCardCode, BCard, BCardText, BProgress, BProgressBar, BTable, BFormDatepicker, BRow, BFormFile, BMedia, BMediaAside, BMediaBody, BCol, BImg, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem, ToastificationContent, BForm, VBModal,
  },
  directives: {
    Ripple,
    'b-modal': VBModal,
  },
  data() {
    return {
      data: [
        {
          icons: require('@/assets/images/icons/site.png'),
          icon: 'UsersIcon',
          color: 'light-warning',
          title: 0,
          subtitle: 'Total',
          customClass: 'mb-3 mb-xl-0',
        },
        {
          icons: require('@/assets/images/icons/online.png'),
          icon: 'UserIcon',
          color: 'light-info',
          title: 0,
          subtitle: 'Online',
          customClass: 'mb-3 mb-xl-0',
        },
        {
          icons: require('@/assets/images/icons/offline.png'),
          icon: 'DollarSignIcon',
          color: 'light-success',
          subtitle: 'Offline',
          title: 0,
          customClass: 'mb-3 mb-sm-0',
        },
        {
          icons: require('@/assets/images/icons/offline.png'),
          icon: '',
          color: 'light-info',
          title: 0,
          subtitle: 'Error',
          customClass: 'mb-3 mb-xl-0',
        },
      ],
      historicalUrl: '/internal/master/devices/historical-devices',
      select_device_type: null,
      select_status: null,
      dir: false,
      modalShow: false,
      currentPage: 1,
      perPage: 10,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      StatusOptions: [
        { title: 'Available', value: 'AC' },
        { title: 'Active', value: 'IN' },
        { title: 'Deleted', value: 'DL' },
      ],
      status: [{
        AC: 'Available', IN: 'Unavailable', DL: 'Deleted', 4: 'Resigned', 5: 'Applied',
      },
      {
        AC: 'light-success', IN: 'light-danger', DL: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
      recoverData: {
        deviceGuid: null,
        startTime: null,
        endTime: null,
      },
      sseData: {
        isProcessing: false,
        progress: 0,
        status: 'start',
        eventSource: null,
        progressMessage: '',
      },
      isLoading: false,
      required,
    }
  },
  computed: {
    ...mapState({
      totalRows: state => state.device.totalRows,
      fields: state => state.device.fields,
      items: state => state.device.items,
      pageOptions: state => state.device.pageOptions,
      DeviceTypeOptions: state => state.temperature.devicetypeoptions,
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    dateFormat() {
      return create_at => this.$options.filters.formatDate(create_at)
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    },
  },
  mounted() {
    // Set the initial number of items
    this.$store.state.totalRows = this.items.length
  },
  created() {
    this.$store.dispatch('device/getFilteredStatus')
    this.$store.dispatch('temperature/getDeviceType')
  },
  methods: {
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: a, icon: b, variant: c, text: d,
        },
      })
    },
    async updateDevice(bvModalEvent) {
      bvModalEvent.preventDefault()

      // validate range date
      const startDate = `${this.recoverData.startTime} 00:00:00`
      const endDate = `${this.recoverData.endTime} 23:59:00`

      const start = moment(startDate, 'YYYY-MM-DD HH:mm:ss')
      const end = moment(endDate, 'YYYY-MM-DD HH:mm:ss')

      if (!start.isBefore(end)) {
        this.notification('Failed', 'CloseIcon', 'danger', 'The start date must be before the end date.')
        return
      }

      const daysDifference = end.diff(start, 'days')
      if (daysDifference > 30) {
        this.notification('Failed', 'CloseIcon', 'danger', 'The date range cannot exceed 30 days.')
        return
      }

      this.isLoading = true
      try {
        const api = process.env.VUE_APP_DEVICE_API
        const isValid = await this.$refs.simpleRules.validate()
        if (!isValid) {
          this.isLoading = false
          return
        }
        this.sseData = {
          ...this.sseData,
          isProcessing: true,
          progress: 0,
          status: 'start',
          eventSource: null,
        }
        const recoveredData = {
          deviceGuid: [this.recoverData.deviceGuid],
          startTime: this.recoverData.startTime ? Math.floor(new Date(start).getTime() / 1000) : null,
          endTime: this.recoverData.endTime ? Math.floor(new Date(end).getTime() / 1000) : null,
        }

        fetch(api + this.historicalUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(recoveredData),
          credentials: 'include',
        }).then(response => {
          const reader = response.body.getReader()
          const decoder = new TextDecoder()
          let partialBuffer = ''

          const processStream = async () => {
            while (true) {
              let complete = false
              // eslint-disable-next-line no-await-in-loop
              const { done, value } = await reader.read()
              if (done || complete) break

              const chunk = decoder.decode(value, { stream: true })
              partialBuffer += chunk

              // Split data by events (separated by \n\n)
              const lines = partialBuffer.split('\n\n')

              // Keep the last incomplete line in the buffer
              partialBuffer = lines.pop()

              lines.forEach(line => {
                if (line.startsWith('data: ')) {
                  const jsonData = line.slice(6)
                  try {
                    const data = JSON.parse(jsonData)
                    this.handleSSEMessage(data)
                    if (data.status === 'complete') {
                      complete = true
                    }
                  } catch (error) {
                    console.error('Error parsing SSE data:', error)
                  }
                }
              })
            }
          }

          processStream().catch(error => {
            console.error('Error processing stream:', error)
          })
        }).catch(error => {
          this.processFailed(error)
          console.error('Error initiating SSE connection:', error)
        })
      } catch (err) {
        console.log(err)
        this.processFailed(err)
        this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
      }
      this.isLoading = false
    },

    handleSSEMessage(data) {
      if (data.status === 'complete') {
        this.processCompleted(data)
      } else if (data.progress !== undefined) {
        this.updateProgress(data.progress, data.message)
      }

      if (data.status === 'failed') {
        this.notification('Failed', 'CloseIcon', 'danger', 'Data not found')
        this.sseData.isProcessing = false
      }
    },

    updateProgress(progress, message) {
      this.sseData.progress = progress
      this.sseData.progressMessage = message
    },

    processCompleted(data) {
      if (data.data.length > 0) {
        this.exportExcel(data.data)
        this.notification('Success', 'CheckIcon', 'success', 'You have successfully exported data')
      } else {
        this.notification('Failed', 'CloseIcon', 'danger', 'Data not found')
      }
      this.resetSseData()
      this.modalShow = false
      if (this.eventSource) {
        this.eventSource.close()
      }
    },

    processFailed(err) {
      this.notification('Failed', 'CloseIcon', 'danger', `You have unsuccessful ${err}`)
      if (this.eventSource) {
        this.eventSource.close()
      }
    },

    resetSseData() {
      this.sseData = {
        isProcessing: false,
        progress: 0,
        status: 'start',
        eventSource: null,
        progressMessage: '',
      }
      this.recoverData = {
        deviceGuid: null,
        startTime: null,
        endTime: null,
      }
      this.$refs.simpleRules.reset()
    },
    async exportExcel(items) {
      const jsons = []
      let projectName = ''
      let siteName = ''
      let siteCode = ''
      let deviceName = ''

      const data = await this.$store.dispatch('device/getBySerial', this.recoverData.deviceGuid)
      if (data) {
        projectName = data.project_name
        siteName = data.site_name
        siteCode = data.site_code
        deviceName = data.name
      }

      items.forEach((item, key) => {
        jsons.push({
          No: key + 1,
          'Project Name': projectName,
          'Site Name': siteName,
          'Site Code': siteCode,
          'Device Name': deviceName,
          'Serial Number': item.device_id,
          'Value Temperature': item.curr_temp,
          'Value Battery': item.battery,
          Time: moment(item.actual_date).format('DD-MM-YYYY HH:mm:ss'),
        })
      })

      const dataJson = XLSX.utils.json_to_sheet(jsons)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataJson, 'data')
      XLSX.writeFile(wb, 'Historical_Data_Devices.xlsx')
    },
  },
}
</script>

<style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";
</style>
